import {
  AnalyticPayloadV3, EventType, EventTypeV3, SeedConfig,
  sendBeaconV3
} from './module/beacon';
import { getCookie, setCookie } from './module/metrics/utils';
import { v4 as uuidv4 } from 'uuid';
import { setBase } from './utils/setBase';
import { pixelsUUIDKey } from './module/metrics/constants';

declare global {
  interface Window {
    pixelsLayer: any[];
    JSGlobals: Record<string, any>; // ESI global variable
    __pixelsLayerKey: string;
  }
}


try {
  // this won't work on IE 11 and below but I don't think it matters
  // because we don't support them?
  let currentSrc = document.currentScript?.getAttribute('src');

  if (!currentSrc.startsWith('http')) {
    currentSrc = window.location.origin + currentSrc;
  }

  const assetUrl = new URL(currentSrc);
  const id = assetUrl.searchParams.get('id');
  const layer = assetUrl.searchParams.get('l') || 'pixelsLayer';

  window.__pixelsLayerKey = layer;

  let basePayload: Partial<AnalyticPayloadV3>;
  let uuid: string = getCookie(pixelsUUIDKey);

  if (!uuid) {
    uuid = uuidv4();
    setCookie(pixelsUUIDKey, uuid, 365);
  }

  const layers = (window as { [key: string]: any })[layer] || [];

  const baseLayer = layers.find(({ id: pageId }: {
    id: string,
    heroVideoId?: string
  }) => Boolean(pageId));

  if (baseLayer) {
    const { heroVideoId, id: pageId, ...rest } = baseLayer;
    if (!basePayload) {
      basePayload = setBase(id, uuid, heroVideoId, pageId);
      sendBeaconV3({
        type: EventTypeV3.PAGE_VIEW,
        ...basePayload,
        ...rest
      });
    }
  }

  // the push method, so it can trigger beacon as it comes
  (window as { [key: string]: any })[layer] = {
    push: (data: AnalyticPayloadV3 | SeedConfig) => {
      // the base config can be set after the pixels layer but before the video wrapper
      if (!basePayload) {
        const { heroVideoId, id: pageId } = data as SeedConfig;
        basePayload = setBase(id, uuid, heroVideoId, pageId);

        return sendBeaconV3({
          type: EventType.PAGE_VIEW,
          ...basePayload,
        } as AnalyticPayloadV3);
      }

      const { id: updatedPageId, ...restOfData } = data as SeedConfig;

      if (updatedPageId) {
        basePayload.page_id = updatedPageId;
      }

      return sendBeaconV3({
        ...basePayload,
        ...restOfData
      } as AnalyticPayloadV3);
    },
  };

  for (const payload of layers.filter(({ type }: { type: string }) => Boolean(type))) {
    (window as { [key: string]: any })[layer].push(payload);
  }
} catch (exception) {
  console.error(exception);
}
